import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  setFacilitiesDetails,
  setIsUpdatedFacility,
  setIsUpdatedPlayer,
  setIsUpdatedStaff,
  setIsUpdatedTeam,
  setPlayerDetails,
  setStaffDetails,
  setTeamDetails,
} from "../../redux/reducers/dataCaptures";
import {
  deleteFacility,
  deletePlayer,
  deleteStaff,
  deleteTeam,
  getFacilitiesDetails,
  getPlayersDetails,
  getStaffDetails,
  getTeamDetails,
} from "../../api/dataCapture";
import DataCaptureMessageModal from "../../components/DataCaptureMessageModal";

const DataCaptureHeaders = (props: any) => {
  const { currentComponent, isFieldsReadOnly, disableClearAll } = props;
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const currentClub = useSelector((state: any) => state.clubDetails);
  const [openInfoBox, setOpenInfoBox] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement | any>(null);  
  const stateComponent = useSelector(
    (state: any) => state.dataCaptures[currentComponent],
  );
  const staffDetails = useSelector(
    (state: any) => state.dataCaptures.staffDetails,
  );
  const facilitiesDetails = useSelector(
    (state: any) => state.dataCaptures.facilitiesDetails,
  );
  const teamDetails = useSelector(
    (state: any) => state.dataCaptures.teamDetails,
  );
  const playerDetails = useSelector(
    (state: any) => state.dataCaptures.playerDetails,
  );

  const managePrePopulate = async (comp: any) => {
    switch (comp) {
      case "staff":
        {
          const deleteStaffs = async () => {
            try {
              if (!openInfoBox) {
                return 0;
              }
              const response = await deleteStaff({
                clubId: currentClub?.id as number,
                id: 0,
              });
              return response;
            } catch (error) {
              console.error("Error while deleting staffs", error);
            }
          };
          deleteStaffs()?.then(() => {
            // dispatch(setStaffDetails({...staffDetails, isClearAllClicked: false}));
            getStaffDetails({
              clubId: currentClub?.id as number,
              isPast: true as boolean,
            }).then((response: any) => {
                dispatch(setStaffDetails(response));
                const tempIsUpdatedStaff:any = true;
                dispatch(setIsUpdatedStaff(tempIsUpdatedStaff));
            });
          });
        }
        break;

      case "facility":
        {
          const deleteFacilities = async () => {
            try {
              if (!openInfoBox) {
                return 0;
              }
              const response = await deleteFacility({
                clubId: currentClub?.id as number,
                id: 0,
              });
              return response;
            } catch (error) {
              console.error("Error while deleting facilities", error);
            }
          };
          deleteFacilities()?.then(() => {
            getFacilitiesDetails({
              clubId: currentClub?.id as number,
              isPast: true as boolean,
            }).then((response: any) => {
                dispatch(setFacilitiesDetails(response));
                const tempIsUpdatedFacility:any = true;
                dispatch(setIsUpdatedFacility(tempIsUpdatedFacility));
            });
          });
        }
        break;

      case "teams":
        {
          const deleteTeams = async () => {
            try {
              if (!openInfoBox) {
                return 0;
              }
              const response = await deleteTeam({
                clubId: currentClub?.id as number,
                id: 0,
              });
              return response;
            } catch (error) {
              console.error("Error while deleting Teams", error);
            }
          };
          deleteTeams()?.then(() => {
            // dispatch(setTeamDetails({...teamDetails, isClearAllClicked: false}));
            getTeamDetails({
              clubId: currentClub?.id as number,
              isPast: true as boolean,
            }).then((response: any) => {
                dispatch(setTeamDetails(response));
                const tempIsUpdatedTeam:any = true;
                dispatch(setIsUpdatedTeam(tempIsUpdatedTeam));
            });
          });
        }
        break;

      case "players":
        {
          const deletePlayers = async () => {
            try {
              if (!openInfoBox) {
                return 0;
              }
              const response = await deletePlayer({
                clubId: currentClub?.id as number,
                id: 0,
              });
              return response;
            } catch (error) {
              console.error("Error while deleting players", error);
            }
          };
          deletePlayers()?.then(() => {
            // dispatch(setPlayerDetails({...playerDetails, isClearAllClicked: false}));
            getPlayersDetails({
              clubId: currentClub?.id as number,
              isPast: true as boolean,
            }).then((response: any) => {
                dispatch(setPlayerDetails(response));
                const tempIsUpdatedPlayer:any = true;
                dispatch(setIsUpdatedPlayer(tempIsUpdatedPlayer));
            });
          });
        }
        break;
    }
  };

  const manageDataChange = (data: any) => {
    const emptyArray: any = [];
    switch (currentComponent) {
      case "staff":
        if (data === 'clearAll') {
            dispatch(setStaffDetails(emptyArray));
            const tempIsUpdatedStaff:any = true;
            dispatch(setIsUpdatedStaff(tempIsUpdatedStaff));
        } else {
          if (staffDetails.length > 0) {
            setOpenInfoBox(true);
          } else {
            managePrePopulate(currentComponent);
          }
        }
        break;

      case "facility":
        if (data === 'clearAll') {
            dispatch(setFacilitiesDetails(emptyArray));
            const tempIsUpdatedFacility:any = true;
            dispatch(setIsUpdatedFacility(tempIsUpdatedFacility));
        } else {
          if (facilitiesDetails.length > 0) {
            setOpenInfoBox(true);
          } else {
            managePrePopulate(currentComponent);
          }
        }
        break;

      case "teams":
        if (data === 'clearAll') {
            dispatch(setTeamDetails(emptyArray));
            const tempIsUpdatedTeam:any = true;
            dispatch(setIsUpdatedTeam(tempIsUpdatedTeam));
        } else {
          if (teamDetails.length > 0) {
            setOpenInfoBox(true);
          } else {
            managePrePopulate(currentComponent);
          }
        }
        break;

      case "players":
        if (data === 'clearAll') {
            dispatch(setPlayerDetails(emptyArray));
            const tempIsUpdatedPlayer:any = true;
            dispatch(setIsUpdatedPlayer(tempIsUpdatedPlayer));
        } else {
          if (playerDetails.length > 0) {
            setOpenInfoBox(true);
          } else {
            managePrePopulate(currentComponent);
          }
        }
        break;
    }
  };

  return (
    <>
      <DataCaptureMessageModal
        isOpen={openInfoBox}
        message={t('DATA_ALREADY_EXIST')}
        onClose={() => {
          setOpenInfoBox(false);
        }}
        prePopulate={true}
        managePrepopulate={() => {
          managePrePopulate(currentComponent);
          setOpenInfoBox(false);
        }}
        anchor={anchorEl}
      />
    <Box sx={{ mt: 1 }}>
      <Button
        className="smallButton"
        sx={{ mr: "10px" }}
        disableElevation
        onClick={(e: any) => {
          setAnchorEl(e.currentTarget);
          manageDataChange(undefined)
        }}
        variant="contained"
        size="small"
        disabled={false}
      >
        {t("PRE_POPULATE_PAST_CYCLE_DATA")}
      </Button>
      <Button
        className="smallButton"
        sx={{ mr: "10px" }}
        disableElevation
        onClick={() =>
          manageDataChange('clearAll')
        }
        variant="contained"
        size="small"
        disabled={disableClearAll}
      >
        {t("CLEAR_ALL_DATA")}
      </Button>
    </Box>
    </>
  );
};

export default DataCaptureHeaders;
